import React, { useMemo } from "react";
import CustomTable from "components/Table/CustomTable";
import { ProductsSchema } from "model/dashboard/products.schema";
import { formatCurrency } from "utils/formatters";
import Image from "components/Common/Image";
import { getImageUrl, ImageSourceType } from "utils/imageUtils";
import useTableChangeHandler from "hooks/useTableChangeHandler";

const ProductTable = ({ data, error, isLoading, onTableChange }) => {
  // HOOK CHANGE
  const { handleSort, handleFilter, handleSearch, handlePageChange } = useTableChangeHandler(onTableChange);

  // COLUMN
  const columns = useMemo(
    () => [
      {
        header: "รายการสินค้า",
        accessor: "name",
        render: (item) => (
          <div className="product-info d-flex align-items-center gap-3">
            <Image src={getImageUrl(item.imgThumbnail, { type: ImageSourceType.NOMAROI })} alt={item.name} />
            <div>
              <div className="text-lg fw-semibold">{item.name}</div>
              <div className="text-md text-gray-500">SKU: {item.sku}</div>
            </div>
          </div>
        ),
      },
      {
        header: "จำนวนลิงค์ที่สร้างไว้",
        accessor: "total_links",
        sortable: true,
        responsive: "lg",
        render: (item) => item.stats.links,
      },
      {
        header: "จำนวนการคลิก",
        accessor: "clicks",
        sortable: true,
        responsive: "md",
        render: (item) => item.stats.clicks,
      },
      {
        header: "Unique Clicks",
        accessor: "uniques",
        sortable: true,
        responsive: "md",
        render: (item) => item.stats.uniques,
      },
      {
        header: "ยอดขายทั้งหมด",
        accessor: "sales",
        sortable: true,
        align: "end",
        render: (item) => <div className="fw-semibold">{formatCurrency(item.stats.sales)}</div>,
      },
      {
        header: "รายได้ทั้งหมด",
        accessor: "earnings",
        sortable: true,
        align: "end",
        render: (item) => <div className="text-primary-600 fw-semibold">{formatCurrency(item.stats.earnings)}</div>,
      },
    ],
    []
  );

  // RENDER
  return (
    <div data-testid="product-table">
      <div className="text-lg mb-4">รายการ Product SKU ในระบบทั้งหมด *{data?.pagination?.total?.toLocaleString() || 0} รายการ *</div>

      <CustomTable
        //
        data={data?.data || []}
        columns={columns}
        // onRowClick={(item) => console.log("Row clicked:", item)}
        className="product-table"
        itemsPerPage={data?.pagination?.limit || 10}
        totalItems={data?.pagination?.total || 0}
        onSort={handleSort}
        onFilter={handleFilter}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        status={isLoading ? "loading" : error ? "error" : data?.data?.length === 0 ? "empty" : "normal"}
        errorMessage={error?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล"}
        emptyMessage="ไม่พบข้อมูลสินค้า"
      />
    </div>
  );
};

const withYupValidation = (WrappedComponent, schema) => {
  return function WithYupValidation(props) {
    try {
      if (!props.isLoading && !props.error && props.data) {
        schema.validateSync(props.data);
      }
      return <WrappedComponent {...props} />;
    } catch (error) {
      return (
        <div className="alert alert-danger">
          <strong>Validation Error:</strong> {error.message}
        </div>
      );
    }
  };
};

const ValidatedTable = withYupValidation(ProductTable, ProductsSchema);

export default ValidatedTable;
